/**
 * Small mark shown above the "Roughly" title on the hub — a target with an
 * off-center dart, standing in for an approximate guess ("roughly" right,
 * not exact). Deliberately small and simple, no mascot/character — see
 * docs/style.md.
 */
export function HubScene({ className }: { className?: string | undefined }) {
  return (
    <svg viewBox="0 0 96 96" className={className} role="presentation" aria-hidden>
      <circle cx="48" cy="48" r="44" fill="#dce6ff" />
      <circle cx="48" cy="48" r="30" fill="none" stroke="#2e6bff" strokeWidth="3" opacity="0.5" />
      <circle cx="48" cy="48" r="18" fill="none" stroke="#2e6bff" strokeWidth="3" opacity="0.7" />
      <circle cx="48" cy="48" r="6" fill="#2e6bff" />
      <circle cx="60" cy="36" r="5" fill="#ffc53d" />
      <path d="M 60 36 L 71 25" stroke="#9b5de5" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
